/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetAssessEnabledResponseContent
 */
export interface SetAssessEnabledResponseContent {
    /**
     * 
     * @type {string}
     * @memberof SetAssessEnabledResponseContent
     */
    message?: string;
}


/**
 * Check if a given object implements the SetAssessEnabledResponseContent interface.
 */
export function instanceOfSetAssessEnabledResponseContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SetAssessEnabledResponseContentFromJSON(json: any): SetAssessEnabledResponseContent {
    return SetAssessEnabledResponseContentFromJSONTyped(json, false);
}

export function SetAssessEnabledResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetAssessEnabledResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function SetAssessEnabledResponseContentToJSON(value?: SetAssessEnabledResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
    };
}

